import { Link } from 'react-router-dom';
import './AuthLayout.scss';
const AuthLayout = ({ leftSideContent, children, footer = true }) => {
  return (
    <div className="auth-page-wrap">
      <div className="auth-card">
        <div className="auth-card-left">
          <div className="auth-card-left-inner">
            <Link to="/" className="auth-brand">FNOTrader</Link>
            <p className="auth-tagline">
              Trader's favorite platform for multi-dimensional real-time analysis and execution
            </p>
            <div className="auth-card-left-footer">
              {leftSideContent}
              {footer && (
                <p className="auth-card-terms">
                  Read our{' '}
                  <Link to="/terms-condition">terms</Link> and{' '}
                  <Link to="/privacy-policy">privacy policy</Link>
                </p>
              )}
            </div>
          </div>
        </div>

        <div className="auth-card-right">
          {children}
        </div>

      </div>
      </div>
  );
};

export default AuthLayout;